import {useFormContext} from "react-hook-form";

import {ServiceTag} from "@/lib/types/checks.ts";
import {AnalyzerCheckCellProps, AnalyzerCreateFormValues} from "@/pages/analyzer/Analyzer.types.ts";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";
import {ChecksTags} from "@/pages/checks/list/components/CheckTags.tsx";

export const AnalyzerCheckTagsCell = ({check}: AnalyzerCheckCellProps) => {
  const {formData} = useAnalyzerContext();
  const {watch} = useFormContext<AnalyzerCreateFormValues>();
  const formTags = watch("tags");
  const names = check.tags ?? formTags.map((tag) => tag.tag);
  const tags = names.map((name) => {
    const formTag = formTags.find((tag) => tag.tag.toLowerCase() === name.toLowerCase());
    const catalogTag = formData?.tags.find((tag) => tag.tag.toLowerCase() === name.toLowerCase());
    return (
      catalogTag ??
      ({id: formTag?.id ?? 0, tag: name, color: 0, color_hex: formTag?.color_hex, usage_count: 0} as ServiceTag)
    );
  });
  if (!tags.length) {
    return null;
  }
  return <ChecksTags tags={tags} />;
};
